<div class="modal" tabindex="-1" role="dialog" id="modalResult" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body"><span class="text-danger text-center font-weight-bold">{{this.message}}</span></div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
      </div>
    </div>
  </div>
</div>
<form [ngClass]="this.partnerType=='SYSTEM'?'g-3':'g-2'"
  class="row mb-2 p-3 border border-1 border-dark bg-white rounded mt-3 mb-2" (ngSubmit)="onFindTransaction()"
  [formGroup]="searchForm">

  @if (this.partner?.canBeParent==true) {
    <div class="form-floating col">
      <select class="form-select" id="idPartner" formControlName="idPartner" name="idPartner">
        <option>Veuillez choisir un partenaire</option>
        @for (merch of merchants; track merch) {
          <option value="{{merch.id}}">{{merch.name}}</option>
        }
      </select>
      <label for="idPartner" class="form-label">Partenaire</label>
    </div>
  }
  <div class="form-floating col">
    <input type="text" class="form-control" placeholder="Entrer la réference" id="reference"
      formControlName="reference">
    <label for="reference" class="form-label">Entrer la réference</label>
  </div>
  @if (this.partnerType=='MERCHANT') {
    <input type="hidden" class="form-control mr-4" id="idPartner"
      formControlName="idPartner" name="idPartner">
  }

  <div class="col">
    <button type="submit" class=" mt-2 btn btn-success w-100">Chercher</button>
  </div>
</form>
<div id="listTransaction" class="row mt-2">

  @if (transactions!!.length>0) {
    <table class="table table-bordered table-hover table-striped text-center" id="tableTrx"
      >
      <thead class="table-success">
        <tr>
          <th class="col">Date</th>
          <th class="col">Montant</th>
          <th class="col">Réference</th>
          @if (partner?.type=='SYSTEM') {
            <th class="col">Partenaire</th>
          }
          @if (partner?.mcc=='8299') {
            <th class="col">Elève</th>
          }
          <th class="col">status</th>
          <th class="col">Action</th>
        </tr>
      </thead>
      <tbody>
        @for (trx of transactions | paginate : pageConfig; track trx) {
          <tr>
            <td>{{trx.paymentDate}}</td>
            <td>{{trx.amount}}</td>
            <td>{{trx.reference}}</td>
            @if (partner?.type!='MERCHANT') {
              <td>{{trx.merchantName}}</td>
            }
            @if (partner?.mcc=='8299') {
              <th>{{trx.bill?.studentName}}</th>
            }
            @if (trx.status=='FAILED') {
              <td class="bg-danger round text-white">&Eacute;CHOU&Eacute;</td>
            }
            @if (trx.status=='PENDING') {
              <td class="bg-warning round text-white">EN ATTENTE</td>
            }
            @if (trx.status=='PAID') {
              <td class="bg-success round text-white">SUCC&Eacute;S</td>
            }
            @if (trx.status=='CANCELED') {
              <td class="bg-secondary round text-white">ANNUL&Eacute;</td>
            }
            <td>@if (trx.status=='PAID') {
              <button type="button" class="btn btn-success" (click)="onDetailsTrx(trx)"
              data-bs-target="detailsTrx">Reçu</button>
            }</td>
          </tr>
        }
      </tbody>
    </table>
  }
  <div class="d-flex justify-content-center">
    @if (transactions && transactions.length>0) {
      <pagination-controls previousLabel="Precedent" nextLabel="Suivant"
        (pageChange)="onNextPage($event)">
      </pagination-controls>
    }
  </div>
  <div class="modal" tabindex="-1" role="dialog" id="detailsTrx">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header bg-success round">
          <h3 class="d-flex align-items-center text-white">D&#233;tails transaction</h3>
        </div>
        <div class="modal-body">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <div class="receipt-container">
                <div class="receipt-container">
                  <img src="favicon.ico">
                  @if (this.receipt?.status=='PAID') {
                    <div class="step-icon success">
                      <i class="fa fa-check-circle text-center"></i>
                    </div>
                  }
                  @if (this.receipt?.status=='FAILED') {
                    <div class="step-icon failed">
                      <i class="fa fa-check-circle text-center"></i>
                    </div>
                  }
                  @if (this.receipt?.status!='FAILED') {
                    <div class="receipt-header text-center fs-1 mb-4 d-flex justify-content-center"
                    >{{receiptType}}</div>
                  }
                  @if (this.receipt?.status=='FAILED') {
                    <span class="receipt-header text-center fs-1 mb-4 d-flex justify-content-center text-danger"
                    >Echec paiment</span>
                  }

                  <div class="mb-4 receipt-details">

                    <h5 class="d-flex justify-content-center">Details Transaction</h5>
                    @if (receipt?.transactionType=='SCHOOLPAY') {
                      <div class="receipt-row">
                        <span class="label">Etablissement : </span>
                        <span class="value">{{receipt?.merchantName}} </span>
                      </div>
                    }
                    @if (receipt?.transactionType=='SCHOOLPAY') {
                      <div class="receipt-row">
                        <span class="label">Nom élève : </span>
                        <span class="value">{{receipt?.bill?.studentName}} </span>
                      </div>
                    }
                    @if (receipt?.transactionType=='SCHOOLPAY') {
                      <div class="receipt-row">
                        <span class="label">Code élève : </span>
                        <span class="value">{{receipt?.bill?.idStudent}} </span>
                      </div>
                    }
                    @if (classe&& classe.yearlyFee) {
                      <div class="receipt-row">
                        <span class="label">Frais annuel: </span>
                        <span class="value">{{classe.yearlyFee}} </span>
                      </div>
                    }
                    @if (classe && classe.apecAmount>0) {
                      <div class="receipt-row">
                        <span class="label">APEC: </span>
                        <span class="value">{{classe.apecAmount}} </span>
                      </div>
                    }
                    @if (classe && classe.firstMonthAmount>0) {
                      <div class="receipt-row">
                        <span class="label">Scolarité Octobre: </span>
                        <span class="value">{{classe.firstMonthAmount}} </span>
                      </div>
                    }

                    @for (item of classe?.otherItems; track item) {
                      <div class="receipt-row">
                        <span class="label">{{item.libelle}}: </span>
                        <span class="value">{{item.value}} </span>
                      </div>
                    }

                    <div class="receipt-row">
                      <span class="label">Reference transaction:</span>
                      <span class="value">{{receipt?.reference}}</span>
                    </div>
                    @if (this.receipt?.status=='PAID'||this.receipt?.status=='VALIDATED') {
                      <div class="receipt-row"
                        >
                        <span class="label">Date:</span>
                        <span class="value">{{receipt?.paymentDate}}</span>
                      </div>
                    }
                    @if (receipt?.paymentNetwork) {
                      <div class="receipt-row">
                        <span class="label">Moyen de paiement:</span>
                        <span class="value">{{receipt?.paymentNetwork}}</span>
                      </div>
                    }
                    <div class="receipt-row">
                      <span class="label">Montant : </span>
                      <span class="total-amount">{{receipt?.amount}} {{receipt?.currencyCode}}</span>
                    </div>
                    @if(taxes.length > 0){
                      @for (tax of taxes; track tax) {
                        <div class="receipt-row">
                          <span class="label">{{tax[0]}} :</span>
                          <span class="value">{{tax[1]}} {{receipt?.currencyCode}}</span>
                        </div>
                      }
                    }

                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>